import { Box } from '@mantine/core';

const showRibbon = import.meta.env.VITE_SHOW_RIBBON === 'true';
const mode = import.meta.env.MODE;
const version = import.meta.env.PACKAGE_VERSION;
const directusUrl = import.meta.env.VITE_DIRECTUS_URL;

const Ribbon = () => {
  if (!showRibbon) {
    return null;
  }

  return (
    <Box
      style={{
        display: 'block',
        backgroundColor: 'rgba(160, 10, 0, 0.5)',
        boxShadow: '0 0 10px #888',
        position: 'fixed',
        top: '45px',
        left: '-55px',
        transform: 'rotate(-45deg)',
        zIndex: 2000,
        pointerEvents: 'none',
        color: 'white',
        whiteSpace: 'nowrap',
        width: '15rem',
        overflow: 'hidden',
        textAlign: 'center',
        fontSize: '14px',
        paddingTop: '5px',
        paddingBottom: '5px',
      }}
      title={`Back URL: ${directusUrl}`}
    >
      {mode} {version}
    </Box>
  );
};

export default Ribbon;
